import * as Colors from "@mui/material/colors";
import themeConfig from "../../theme/themeConfig.json";

declare module "@mui/material/styles" {
  interface Palette {
    tomato: Palette["primary"];
    pink: {
      deep: string;
      hot: string;
      medium: string;
      pale: string;
      light: string;
    };
    white: Palette["primary"];
    black: Palette["primary"];
  }
  interface PaletteOptions {
    tomato?: PaletteOptions["primary"];
    pink?: {
      deep?: string;
      hot?: string;
      medium?: string;
      pale?: string;
      light?: string;
    };
    white?: PaletteOptions["primary"];
    black?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    tomato: true;
    white: true;
    black: true;
  }
}

const colorPalette = {
  ...Colors,
  primary: {
    ...Colors.blue,
    main: themeConfig.colors.action.DEFAULT,
    contrastText: themeConfig.colors.action.foreground,
  },
  tomato: {
    main: "#FF6347",
    contrastText: "#FFFFFF",
  },
  pink: {
    deep: "#FF1493",
    hot: "#FF69B4",
    medium: "#C71585",
    pale: "#DB7093",
    light: "#FFB6C1",
  },
  white: {
    main: "#FFFFFF",
    contrastText: "#000000",
  },
  black: {
    main: "#000000",
    contrastText: "#FFFFFF",
  },
  red: Colors.red[500],
};

export default colorPalette;
